module.exports = __webpack_public_path__ + "static/media/bts_boots_170817_011_small.80e6b0a0.jpg";